import { Grid, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SaleTransactionStage } from '../../../api';
import TabPanel from '../../../components/TabPanel';
import useCommonStyles from '../../../useCommonStyles';
import MenuTabs from './AllSessionsMenuTabs';
import SalesTransactionsTab from './SalesTransactionsTab';

const a11yProps = (index: string) => ({
    id: `bidding-sessions-tab-${index}`,
    'aria-controls': `bidding-sessions-tabpanel-${index}`,
});

const AllBiddingSessions = () => {
    const { t } = useTranslation(['common']);
    const commonStyles = useCommonStyles();
    const [value, setValue] = useState('currentBiddingSessions');

    return (
        <Grid spacing={2} container>
            <Grid xs={12} item>
                <Typography className={commonStyles.title}>{t('common:titles.allBiddingSessions')}</Typography>
            </Grid>
            <Grid xs={12} item>
                <MenuTabs a11yProps={a11yProps} setValue={setValue} value={value} />
            </Grid>
            <Grid xs={12} item>
                <TabPanel index="currentBiddingSessions" value={value}>
                    <SalesTransactionsTab stages={[SaleTransactionStage.BiddingOpen]} />
                </TabPanel>
                <TabPanel index="upcomingBiddingSessions" value={value}>
                    <SalesTransactionsTab stages={[SaleTransactionStage.UpcomingBidding]} />
                </TabPanel>
            </Grid>
        </Grid>
    );
};

export default AllBiddingSessions;
